<template>
  <div class="search-proposal">
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <div>
          <div>
            <el-form-item :label="`${$t('proposal.condition.target')}:`">
              <el-autocomplete
                size="mini"
                placeholder=""
                style="width: 220px"
                v-model="searchParams.target"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                clearable>
              </el-autocomplete>
            </el-form-item>

            <el-form-item :label="`${$t('proposal.condition.position')}:`">
              <el-input size="mini" style="width: 120px" v-model="searchParams.ra" placeholder="ra"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input size="mini" style="width: 120px" v-model="searchParams.dec" placeholder="dec"></el-input>
            </el-form-item>

            <el-form-item :label="`${$t('proposal.condition.radius')}:`">
              <el-input size="mini" v-model="searchParams.radius" style="width: 60px" placeholder="1"></el-input>
            </el-form-item>
            <el-divider class="el-divider" ></el-divider>
            <el-form-item :label="`${$t('proposal.condition.start_utc')}:`">
              <el-date-picker
                size='mini'
                v-model="searchParams.start_utc"
                format="yyyy-MM-ddTHH:mm:ss"
                value-format="yyyy-MM-ddTHH:mm:ss"
                type="datetime"
                style="width: 200px"
                clearable>
              </el-date-picker>
            </el-form-item>

            <el-form-item :label="`${$t('proposal.condition.stop_utc')}:`">
              <el-date-picker
                size='mini'
                v-model="searchParams.stop_utc"
                format="yyyy-MM-ddTHH:mm:ss"
                value-format="yyyy-MM-ddTHH:mm:ss"
                type="datetime"
                style="width: 200px"
                clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="searchParams.isopen">{{$t('proposal.condition.isopen')}}</el-checkbox>
            </el-form-item>
          </div>
          
        </div>
        <el-divider class="el-divider" ></el-divider>
        <el-form-item :label="`${$t('proposal.condition.ptype')}:`">
          <el-select clearable size="mini" v-model="searchParams.ptype" style="width: 100px" placeholder="">
            <el-option
              v-for="item in proposaltype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('proposal.condition.obs_mode')}:`">
          <el-select clearable size="mini" v-model="searchParams.obs_mode" style="width: 200px" placeholder="">
            <el-option
              v-for="item in obsmodes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('proposal.obs_id')}:`">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 200px"
            v-model="searchParams.obs_id"
            :fetch-suggestions="obsquerySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
          <!-- <el-input size="mini" v-model="searchParams.obs_id" style="width: 200px" clearable></el-input> -->
        </el-form-item>

        <el-divider class="el-divider" v-if="isShowMoreConditions"></el-divider>

        <el-form-item v-show="isShowMoreConditions" :label="`${$t('proposal.condition.tstart')}:`">
          <el-input size="mini" v-model="searchParams.tstart" style="width: 120px"></el-input>
        </el-form-item>

        <el-form-item v-show="isShowMoreConditions" :label="`${$t('proposal.condition.tstop')}:`">
          <el-input size="mini" v-model="searchParams.tstop" style="width: 120px"></el-input>
        </el-form-item>

        <el-divider class="el-divider" v-if="isShowMoreConditions"></el-divider>

        <el-form-item v-show="isShowMoreConditions" :label="`${$t('proposal.condition.schedule_id')}:`">
          <el-input size="mini" v-model="searchParams.schedule_id"></el-input>
        </el-form-item>

        <el-form-item v-show="isShowMoreConditions" :label="`${$t('proposal.proposal')}:`">
          <el-input size="mini" v-model="searchParams.proposal" clearable></el-input>
        </el-form-item>
        

        <!-- <el-form-item v-show="isShowMoreConditions" :label="`${$t('proposal.obs_id')}:`">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 200px"
            v-model="searchParams.obs_id"
            :fetch-suggestions="obsquerySearch"
            :trigger-on-focus="false">
          </el-autocomplete>
        </el-form-item> -->

        <el-form-item v-show="isShowMoreConditions">
          <el-checkbox v-model="searchParams.isarchived">{{$t('proposal.condition.isarchived')}}</el-checkbox>
        </el-form-item>

        <el-form-item v-show="isShowMoreConditions">
          <el-radio-group v-model="searchParams.operation" v-if="userInfo">
            <el-radio :label="1">{{$t('proposal.condition.all')}}</el-radio>
            <el-radio :label="2">{{$t('proposal.condition.download')}}</el-radio>
            <el-radio :label="3">{{$t('proposal.condition.appliable')}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' type="primary"  @click="showmorecon">
            <template v-if="isShowMoreConditions">
              {{$t('proposal.condition.less')}}
            </template>
            <template v-else>
              {{$t('proposal.condition.more')}}
            </template>
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' type="primary" @click="ClearSearch">{{$t('proposal.condition.clear')}}</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size='mini' style="width:100px;" type="primary" @click="onSubmit">{{$t('proposal.condition.search')}}</el-button>
        </el-form-item>
        <el-divider class="el-divider" v-if="isShowMoreConditions"></el-divider>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="list" 
        @selection-change="handleSelectionChange"
        @sort-change="sortChange">
        <el-table-column
          fixed
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          prop="id"
          label="id"
          v-if="false">
        </el-table-column>  

        <el-table-column
          prop="obs_id"
          width="120"
          sortable="custom"
          :label="$t('proposal.obs_id')">
          <template slot-scope="scope">
            <span :title="$t('proposal.tip.obs_id')" >
              <router-link v-bind:to="`/infoobs/`+scope.row.id">{{scope.row.obs_id}}</router-link>
              <!-- <a :href="`/infoobs/$t{'scope.row.id}`" target="_blank" class="buttonText">{{scope.row.obs_id}}</a> -->
            </span>
          </template>
     
        </el-table-column>

        <el-table-column
          prop="proposal"
          sortable="custom"
          :label="$t('proposal.proposal')"
          v-if="true">
          <template slot-scope="scope">
            <span :title="$t('proposal.tip.proposal')">
              <router-link v-bind:to="`/infoproposal/`+scope.row.id">{{scope.row.proposal}}</router-link>
            </span>
          </template>
        </el-table-column>  

        <el-table-column
          prop="schedule_id"
          v-if="isShowschedule_id"
          width="120"
          sortable="custom"
          :label="$t('proposal.schedule_id')">
          <template slot-scope="{row}">
            <span :title="$t('proposal.tip.schedule_id')">{{row.schedule_id}}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="50"
          :label="$t('proposal.ptype')">
          <template slot-scope="{row}">
            <span :title="$t(`proposal.ptype_data.${row.ptype}`)">{{row.ptype}}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="55"
          :label="$t('proposal.obs_mode')">
          <template slot-scope="{row}">
            <span :title="$t(`proposal.obsmode_data.${row.obs_mode}`)">{{row.obs_mode}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="target"
          sortable="custom"
          :label="$t('proposal.target')">
          <template slot-scope="scope">
            <span :title="$t('proposal.tip.target')">
              <router-link v-bind:to="`/infotarget/`+scope.row.id">{{scope.row.target}}</router-link>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="ra"
          sortable="custom"
          :label="$t('proposal.ra')">
        </el-table-column>

        <el-table-column
          prop="dec"
          sortable="custom"
          :label="$t('proposal.dec')">
        </el-table-column>

        <el-table-column
          prop="offset_c"
          v-if="isShowOffsetCol"
          width="58"
          :label="$t('proposal.offset_c')">
          <template slot-scope="{row}">
            <span :title="$t('proposal.tip.offset_c')">{{row.offset_c}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="start_utc"
          sortable="custom"
          :label="$t('proposal.start_utc')">
        </el-table-column>

        <el-table-column
          :label="$t('proposal.tstart')">
          <template slot-scope="{row}">
            <span :title="$t('proposal.tip.tstart')">{{row.tstart}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="stop_utc"
          sortable="custom"
          :label="$t('proposal.stop_utc')">
        </el-table-column>

        <el-table-column
          :label="$t('proposal.tsop')">
          <template slot-scope="{row}">
            <span :title="$t('proposal.tip.tsop')">{{row.tsop}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="duration"
          sortable="custom"
          :label="$t('proposal.duration')">
          <template slot-scope="{row}">
            <span :title="$t(`proposal.tip.duration`)">{{row.duration}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          width="58"
          :label="$t('proposal.status')">
          <template slot-scope="scope">
            <span :title="$t(`proposal.status_data.${scope.row.status}`)">{{scope.row.status}}
              <!-- <router-link  v-bind:to="`/infoquicklook/`+scope.row.id" >{{scope.row.status}}</router-link> -->
            </span>
          </template>
        </el-table-column>

        <el-table-column
          width="55"
          :label="$t('proposal.isopen')">
          <template slot-scope="{row}">
            <span :title="$t(`proposal.isopen_data.${row.isopen}`)">{{row.isopen}}</span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('proposal.operate')"
          width="260">
          <template slot="header" >
            <div>
            <!-- 2024年5月24日 修改逻辑，所有访客都可直接下载公开数据 -->
              <!-- <el-button v-if="this.userInfo" class="op-btn" size="small" @click="batchapply"> -->
              <!-- <el-button  class="op-btn" size="small" @click="batchapply"> -->
                <!-- {{$t('proposal.batch_application')}}  -->
              <!-- </el-button> -->
            </div>
            <div>
              <!-- 2024年5月24日 修改逻辑，所有访客都可直接下载公开数据 -->
              <!-- <div class="selected-levels" v-if="this.userInfo"> -->
              <div class="selected-levels" >
                <div class="level-item" :class="{'level-item-active': level1L}"  @click="tabSelection('1L')">1L</div>
                <div class="level-item" :class="{'level-item-active': level15L}"  @click="tabSelection('15L')">1.5L</div>
                <div class="level-item" :class="{'level-item-active': level2L}"  @click="tabSelection('2L')">2L</div>
              </div>
              <!-- 2024年5月24日 修改逻辑，所有访客都可直接下载公开数据 -->
              <!-- <el-dropdown @command="handleBulkDownload" v-if="this.userInfo"> -->
              <el-dropdown @command="handleBulkDownload" >
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.bulk_down')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'bulkdown'}">
                    {{$t('proposal.bulkwebdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkcopy'}">
                    {{$t('proposal.bulkcopy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkwget'}">
                    {{$t('proposal.bulkget_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <template slot-scope="scope" >
            <div >
              <!-- 申请 -->
              <el-button
                v-show="scope.row.isApply"
                class="op-btn"
                size="small"
                @click="apply(scope.row)">
                {{$t('proposal.apply')}} 
              </el-button>

              <!-- 下载 -->
              <div class="selected-levels" v-show="scope.row.isDownload">
                <template v-for="(levelItem, i) in scope.row.selectedLevels">
                  <el-tooltip class="item" 
                  :key="levelItem.level" 
                  v-if="levelItem.isShow" 
                  effect="dark" 
                  :content="`${levelItem.filelength}`" 
                  placement="top-start">
                    <div
                      class="level-item"
                      :class="{'level-item-active': levelItem.value}"
                      @click="toggleSelection(scope, i)">
                      {{levelItem.name}}
                    </div>
                </el-tooltip>
                </template>
              </div>
              <el-dropdown @command="handleDownload" v-show="scope.row.isDownload">
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.download')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'download', row: scope.row}">
                    {{$t('proposal.webdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'copy', row: scope.row}">
                    {{$t('proposal.copy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'wget', row: scope.row}">
                    {{$t('proposal.get_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-badge
                v-show="scope.row.isupgrade" 
                :value="scope.row.isnew" 
                class="upk-levels"
                size="small">
                <el-button 
                  size="small" 
                  class="upklevel-item" 
                  @click="UpPackagedown(scope.row.obs_id)">
                  {{$t('proposal.UpPackage')}}
                </el-button>
              </el-badge>
              <el-button
                v-show="scope.row.isownergen"
                class="op-btn"
                size="small"
                @click="Ownerauth(scope.row)">
                {{$t('proposal.OwnerAuth')}} 
              </el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-sizes.sync="pageSizes"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="getData"
        @current-change="getData">
      </el-pagination>

      <NoLoginApplyDialog
        :dialog-visible="noLoginApplyIsVisible"
        :dialog-type="tabletype"
        :dialog-data="currentDataId"
        @ok="confirmNoLoginApplyDialog"
        @close="closeNoLoginApplyDialog">
      </NoLoginApplyDialog>

      <!-- <LoginApplyDialog
        :dialog-visible="LoginApplyIsVisible"
        :dialog-type="tabletype"
        :dialog-data="logincurrentDataId"
        @ok="confirmLoginApplyDialog"
        @close="closeLoginApplyDialog">
      </LoginApplyDialog> -->


      <LoginApplyDialogAppByPm
        :dialog-visible="LoginApplyIsVisible"
        :dialog-type="tabletype"
        :dialog-data="logincurrentDataId"
        @ok="confirmLoginApplyDialog"
        @close="closeLoginApplyDialog">
      </LoginApplyDialogAppByPm>

      <LoginApplyDialogbulk
        :dialog-visible="LoginApplyIsVisiblebulk"
        :dialog-data="logincurrentDataIdbulk"
        @ok="confirmLoginApplyDialogbulk"
        @close="closeLoginApplyDialogbulk">
      </LoginApplyDialogbulk>

      <copyTextDialog
        :dialog-visible="copyTextDialogVisible"
        :dialog-data="copyTextDialogData"
        @close="closeCopyTextDialog">
      </copyTextDialog>
    </div>
  </div>
</template>

<script>
import { proposaltype,ObsModes } from '../common';
import axios from 'axios';
import NoLoginApplyDialog from './NoLoginApplyDialog.vue';
import LoginApplyDialogAppByPm from './LoginApplyDialogAppByPm.vue';
import LoginApplyDialogbulk from './LoginApplyDialogbulk.vue';
import { mapState } from 'vuex';
import copyTextDialog from './copyTextDialog';

export default {
  components: {
    LoginApplyDialogbulk,
    NoLoginApplyDialog,
    LoginApplyDialogAppByPm,
    copyTextDialog,
  },
  data() {
    return {
      searchParams: {
        target: '',
        ra: '',
        dec: '',
        radius: 1,
        start_utc: '',
        stop_utc: '',
        isopen: false,
        ptype: '',
        obs_mode:'',
        schedule_id: '',
        tstart: '',
        tstop: '',
        obs_id: '',
        isarchived: false,
        operation: 1,
        proposal:'',
      },
      // level1L:false,
      // level15L:false,
      // level2L:false,
      isShowOffsetCol:false,
      isShowMoreConditions: false,
      isShowschedule_id: false,
      list: [],
      restaurants: [],
      obsrestaurants: [],
      currentPage: 1,
      pageSizes:[10,20, 50, 100, 200,300],
      pageSize: 10,
      total: 0,
      proposaltype: proposaltype,
      obsmodes:ObsModes,
      noLoginApplyIsVisible: false,
      currentDataId: null,
      tabletype:'',
      LoginApplyIsVisible:false,
      logincurrentDataId:null,
      LoginApplyIsVisiblebulk:false,
      logincurrentDataIdbulk:[],
      orderDirection: null,
      orderProp: '',
      copyTextDialogVisible: false,
      copyTextDialogData: '',
      multipleSelection:[],
      isnew:'',
    };
  },
  created() {
    this.getlocal_search();
    this.getData();
    this.gettargetdata();
  },
  computed: {
    ...mapState([
      'userInfo',
    ]),
    level1L() {
      const list = this.list.filter((item) => {
        return item.selectedLevels.some((levelItem) => {
          return levelItem.level === '1L' && levelItem.isShow && item.isDownload;
        });
      });
      if(list.length>0){
        return list.every((item) => {
          return item.selectedLevels.some((levelItem) => {
            return levelItem.level === '1L' && levelItem.isShow && levelItem.value && item.isDownload;
          });
        });
      }else{
        return false;
      }
      // return list.every((item) => {
      //   return item.selectedLevels.some((levelItem) => {
      //     return levelItem.level === '1L' && levelItem.isShow && levelItem.value && item.isDownload;
      //   });
      // });
    },
    level15L() {
      const list = this.list.filter((item) => {
        return item.selectedLevels.some((levelItem) => {
          return levelItem.level === '15L' && levelItem.isShow && item.isDownload;
        });
      });
      if(list.length>0){
        return list.every((item) => {
          return item.selectedLevels.some((levelItem) => {
            return levelItem.level === '15L' && levelItem.isShow && levelItem.value && item.isDownload;
          });
        });
      }else{
        return false;
      }
      // return list.every((item) => {
      //   return item.selectedLevels.some((levelItem) => {
      //     return levelItem.level === '15L' && levelItem.isShow && levelItem.value && item.isDownload;
      //   });
      // });
    },
    level2L() {
      const list = this.list.filter((item) => {
        return item.selectedLevels.some((levelItem) => {
          return levelItem.level === '2L' && levelItem.isShow && item.isDownload;
        });
      });
      if(list.length>0){
        return list.every((item) => {
          return item.selectedLevels.some((levelItem) => {
            return levelItem.level === '2L' && levelItem.isShow && levelItem.value && item.isDownload;
          });
        });
      }else{
        return false;
      }
    },
  },
  methods: {
    getData() {

        const params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          ...this.searchParams,
        };
      
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }

      axios.post('/iapi/data', params).then((res) => {
        if (res.data.errcode === 0) {
          this.setlocal_search();
          this.total = res.data.data.total;
          this.list = res.data.data.list.map((item) => {
            let isDownload = false;
            let isApply = false;
            let isupgrade = false;
            let ownerisself=false;
            let isownergen=false;
            
            // let isQuick = false; 
            let is1L = !!item.l1_file_id; 
            let is15L = !!item.l15_file_id;
            let is2L = !!item.l2_file_id;
            
            let isnew = item.upgradenew===false ? '':'new';
            let selectedLevels = [
              {
                level: '1L',
                name: '1L',
                isShow: is1L,
                value: false,
                filelength: item.l1_filelength===null?'':item.l1_filelength,
                filename: item.l1_filename===null ? '': item.l1_filename,
              },
              {
                level: '15L',
                name: '1.5L',
                isShow: is15L,
                value: false,
                filelength: item.l15_filelength===null?'':item.l15_filelength,
                filename: item.l15_filename===null ? '': item.l15_filename,
              },
              {
                level: '2L',
                name: '2L',
                isShow: is2L,
                value: false,
                filelength: item.l2_filelength===null?'':item.l2_filelength,
                filename: item.l2_filename===null ? '': item.l2_filename,
              },
            ];

            if (!this.userInfo) {           
              //2024年5月24日 变更逻辑,所有公开数据都可以直接下载，不需要申请
              // isApply = item.status === 'A' && item.isopen === 1 && ( is1L || is15L || is2L) ;
              // isDownload = item.status === 'A' && ( item.isopen === 1 || item.isAuthed ==='ok' )&& ( is1L || is15L || is2L);
              isDownload = item.status === 'A' && ( item.isopen === 1 )&& ( is1L || is15L || is2L);
              //2024年5月24日 变更逻辑,所有公开数据都可以直接下载，不需要申请
              // isupgrade = item.isupgrade && isApply;
              isupgrade = item.isupgrade && isDownload;
              
            } else {
              //判断是否owner
              if(this.userInfo.owner){
                ownerisself = this.userInfo.owner.split(',').some((usrow)=>{
                  return item.owner.split(',').some((datow)=>{
                      return usrow===datow ;
                  });
                });
              }
              if (!ownerisself) {
                ownerisself = this.userInfo.useremail === item.owner
              }
              //申请时不考虑文件是否存在,如果需要,加入判断条件   && ( is1L || is15L || is2L)
              isApply = item.status ==='A' && item.isopen === 0 && item.isAuthed==='no' && !ownerisself;
              //2024年5月23日 变更逻辑,所有公开数据都可以直接下载，不需要申请
              // isDownload = item.status === 'A' && ( item.isopen === 1 || item.isAuthed ==='ok' )&& ( is1L || is15L || is2L);
              isDownload = item.status === 'A' && ( item.isopen === 1 || item.isAuthed ==='ok')&& ( is1L || is15L || is2L);
              isupgrade = item.isupgrade && isDownload;
              isownergen = item.status === 'A' && ownerisself && item.isAuthed==='no' && !isDownload ;
            }
            // isQuick = item.status ==='A';
            return {
              ...item,
              isDownload,
              isApply,
              // isQuick,
              is1L,
              is15L,
              is2L,
              selectedLevels,
              isnew,
              isupgrade,
              isownergen,
            }
          });
        } else {
          this.$message.error('数据接口错误');
        }
      });
      // console.log('list',this.list);
    },
    onSubmit() {
      if(!this.checkpositioninput()){
        return null;
      }
      if(this.searchParams.schedule_id){
        this.isShowschedule_id = true;
      }else{
        this.isShowschedule_id = false;
      }
      this.currentPage = 1;
      this.getData();
    },
    checkpositioninput(){
      if (this.searchParams.ra || this.searchParams.dec ) {

        if (!this.searchParams.ra || !this.searchParams.dec) {
          alert(this.$t('messinfo.positioninput'));
          return false;
        }

        let raIsOK = false;
        if (/^\d{1,3}(\.\d+)?$/.test(this.searchParams.ra)
          && Number(this.searchParams.ra) >= 0
          && Number(this.searchParams.ra) < 360) {
          raIsOK = true;
        }

        if (!raIsOK && /^\d{1,2} \d{1,2} \d+(\.\d+)?$/.test(this.searchParams.ra)) {
          let raArr = this.searchParams.ra.split(' ');
          // console.log('raArr',raArr);
          if (Number(raArr[0]) >= 0
            && Number(raArr[0]) < 24
            && Number(raArr[1]) >= 0
            && Number(raArr[1]) < 60
            && Number(raArr[2]) >= 0
            && Number(raArr[2]) < 60) {
            raIsOK = true;
          }
        }

        if (!raIsOK) {
          alert(this.$t('messinfo.rainput'));
          return false;
        }

        let decIsOK = false;
        if (/^(\+|-)?\d{1,3}(\.\d+)?$/.test(this.searchParams.dec)
          && Number(this.searchParams.dec) >= -90
          && Number(this.searchParams.dec) <= 90) {
          decIsOK = true;
        }

        if (!decIsOK && /^(\+|-)?\d{1,2} \d{1,2} \d+(\.\d+)?$/.test(this.searchParams.dec)) {
          let raArr = this.searchParams.dec.split(' ');
          if (Number(raArr[0]) > -90
            && Number(raArr[0]) < 90
            && Number(raArr[1]) >= 0
            && Number(raArr[1]) < 60
            && Number(raArr[2]) >= 0
            && Number(raArr[2]) < 60) {
            decIsOK = true;
          }
        }

        if (!decIsOK) {
          alert(this.$t('messinfo.decinput'));
          return false;
        }

        if (this.searchParams.radius && !(/^\d+(\.\d+)?$/.test(this.searchParams.radius))) {
          alert(this.$t('messinfo.radiusinput'));
          return false;
        }
          
        this.isShowOffsetCol = true;
        return true;          
      } else {
        this.isShowOffsetCol = false;
        return true;
      }
    },
    showmorecon(){
      this.isShowMoreConditions = !this.isShowMoreConditions;
      if(!this.isShowMoreConditions){
        this.searchParams.schedule_id = '';
        this.searchParams.tstart = '';
        this.searchParams.tstop = '';
        this.searchParams.isarchived = false;
        this.searchParams.operation = 1;
        this.searchParams.proposal = '';
      }
    },
    closeNoLoginApplyDialog() {
      this.noLoginApplyIsVisible = false;
    },
    closeLoginApplyDialog(){
      this.LoginApplyIsVisible = false;
    },
    closeLoginApplyDialogbulk(){
      this.LoginApplyIsVisiblebulk = false;
    },
    confirmNoLoginApplyDialog(data) {
      this.closeNoLoginApplyDialog();
      const params = {
        name:data.name,
        id:data.id,
        ogs_id:data.ogs_id,
        level:data.level,
        remark:data.remark,
        applyemail:data.applyemail,
        applycop:data.applycop,
        data_type:'OBS',
      }
      axios.post('/iapi/apply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }else if (res.data.errcode === 1) {
          alert('请不要重复申请!(Please do not repeat the application!)');
        }
      });
    },

    confirmLoginApplyDialog(data) {
      this.closeLoginApplyDialog();
      const params = {
        umtId : data.umtId,
        cstnetId : data.cstnetId,
        id : data.id,
        obs_id : data.obs_id,
        target : data.target,
        obs_mode : data.obs_mode,
        proposal : data.proposal,
        includeproposal:data.includeproposal,
        name : data.name,
        useremail : data.useremail,
        applycop : data.applycop,
        userposition : data.userposition,
        remark : data.remark,
        tutorname : data.tutorname,
        tutoremail : data.tutoremail,
        partnersname : data.partnersname,
        partnersemail : data.partnersemail,
      }
      // console.log(params);
      axios.post('/iapi/userapply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }else if (res.data.errcode === 1) {
          alert('请不要重复申请!(Please do not repeat the application!)');
        }
      });
    },
    confirmLoginApplyDialogbulk(data) {
      this.closeLoginApplyDialogbulk();
      // console.log('确认数据',data);
      const params = {
        umtId : data.umtId,
        cstnetId : data.cstnetId,
        includeproposal:data.includeproposal,
        name : data.name,
        useremail : data.useremail,
        applycop : data.applycop,
        userposition : data.userposition,
        remark : data.remark,
        tutorname : data.tutorname,
        tutoremail : data.tutoremail,
        partnersname : data.partnersname,
        partnersemail : data.partnersemail,
        list : data.list,
      }
      axios.post('/iapi/bulkapply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }else if (res.data.errcode === 1) {
          alert('请不要重复申请!(Please do not repeat the application!)');
        }
      });
    },
    apply(dataId) {
      this.tabletype = 'OBS';
      if(this.userInfo){
        // console.log("登录用户姓名",this.userInfo.truename);
        this.logincurrentDataId = dataId;
        this.LoginApplyIsVisible = true;
      }else{
        this.currentDataId = dataId;
        this.noLoginApplyIsVisible = true;
      }      
    },

    gettargetdata(){
      const params = {
      }
      axios.post('/iapi/gettarlist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          this.obsrestaurants = res.data.obs_id;
        }
      });
    },
    obsquerySearch(queryString, cb) {
      let obsrestaurants = this.obsrestaurants;
      let results = queryString ? obsrestaurants.filter(this.obscreateFilter(queryString)) : obsrestaurants;
      cb(results);
    },
    obscreateFilter(queryString) {
      return (obsrestaurants) => {
        return (obsrestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) == 0);
      };
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        // restaurant.value 数据存在为null的情况
        if (restaurant.value) {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
        }
        return false
      };
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },
    handleDownload(data) {
      let urls = data.row.selectedLevels.filter((item) => {
        return item.isShow && item.value;
      }).map((item) => {
        if(data.row.isAuthed === 'ok' && !(data.type === 'wget')) {
          return window.location.protocol+'//'+window.location.host+'/iapi/usrdownload/'+item.level+'/'+data.row.auth_code;
        } else if(!(data.row.isAuthed === 'ok') && !(data.type === 'wget')) {
          if (!this.userInfo) {
            return window.location.protocol+'//'+window.location.host+'/iapi/downloadopen/'+item.level+'/'+data.row.auth_code;
          }
          return window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/'+item.level+'/'+data.row.auth_code;
        }else if(data.row.isAuthed === 'ok' && data.type === 'wget'){
          return ' wget -c -t 0 -O '+item.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/usrdownload/'+item.level+'/'+data.row.auth_code;
        }else if(!(data.row.isAuthed === 'ok') && data.type === 'wget'){
          if (!this.userInfo) {
            return ' wget -c -t 0 -O '+item.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/downloadopen/'+item.level+'/'+data.row.auth_code;
          }
          return ' wget -c -t 0 -O '+item.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/'+item.level+'/'+data.row.auth_code;
        }
      });
      if(urls.length<1){
        alert('请选择要下载的数据产品级别!(Please select the data product level to download)');
        return;
      }
      if (data.type === 'download') {
        urls.forEach((item) => {
          // console.log('下载地址',item);
          // window.open(item);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = item; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
        });
      }
      if (data.type === 'copy') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'wget') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
      }
    },
    closeCopyTextDialog() {
      this.copyTextDialogVisible = false;
    },
    ClearSearch(){
      this.searchParams.target = '';
      this.searchParams.ra = '';
      this.searchParams.dec = '';
      this.searchParams.radius = 1;
      this.searchParams.start_utc = '';
      this.searchParams.stop_utc = '';
      this.searchParams.isopen = false;
      this.searchParams.ptype = '';
      this.searchParams.obs_mode = '';
      this.searchParams.schedule_id = '';
      this.searchParams.tstart = '';
      this.searchParams.tstop = '';
      this.searchParams.obs_id = '';
      this.searchParams.isarchived = false;
      this.searchParams.operation = 1;
      this.searchParams.proposal = '';
    },
    setlocal_search(){
      sessionStorage.setItem('target',this.searchParams.target);
      sessionStorage.setItem('ra',this.searchParams.ra);
      sessionStorage.setItem('dec',this.searchParams.dec);
      sessionStorage.setItem('radius',this.searchParams.radius);
      sessionStorage.setItem('start_utc',this.searchParams.start_utc);
      sessionStorage.setItem('stop_utc',this.searchParams.stop_utc);
      sessionStorage.setItem('isopen',this.searchParams.isopen);
      sessionStorage.setItem('ptype',this.searchParams.ptype);
      sessionStorage.setItem('obs_mode',this.searchParams.obs_mode);
      sessionStorage.setItem('schedule_id',this.searchParams.schedule_id);
      sessionStorage.setItem('tstart',this.searchParams.tstart);
      sessionStorage.setItem('tstop',this.searchParams.tstop);
      sessionStorage.setItem('obs_id',this.searchParams.obs_id);
      sessionStorage.setItem('isarchived',this.searchParams.isarchived);
      sessionStorage.setItem('operation',this.searchParams.operation);
      sessionStorage.setItem('proposal',this.searchParams.proposal);

      sessionStorage.setItem('currentPage',this.currentPage);
      sessionStorage.setItem('pageSize',this.pageSize);
    },
    getlocal_search(){
      this.searchParams.target = sessionStorage.getItem('target')===null ? '' : sessionStorage.getItem('target');
      this.searchParams.ra = sessionStorage.getItem('ra')===null ? '' : sessionStorage.getItem('ra');
      this.searchParams.dec = sessionStorage.getItem('dec')===null ? '' : sessionStorage.getItem('dec');
      this.searchParams.radius = sessionStorage.getItem('radius')===null ? 1 : sessionStorage.getItem('radius');
      this.searchParams.start_utc = sessionStorage.getItem('start_utc')===null ? '' : sessionStorage.getItem('start_utc');
      this.searchParams.stop_utc = sessionStorage.getItem('stop_utc')===null ? '' : sessionStorage.getItem('stop_utc');
      this.searchParams.isopen = sessionStorage.getItem('isopen')==='true' ? true : false;
      this.searchParams.ptype = sessionStorage.getItem('ptype')===null ? '' : sessionStorage.getItem('ptype');
      this.searchParams.obs_mode = sessionStorage.getItem('obs_mode')===null ? '' : sessionStorage.getItem('obs_mode');
      this.searchParams.schedule_id = sessionStorage.getItem('schedule_id')===null ? '' : sessionStorage.getItem('schedule_id');
      this.searchParams.tstart = sessionStorage.getItem('tstart')===null ? '' : sessionStorage.getItem('tstart');
      this.searchParams.tstop = sessionStorage.getItem('tstop')===null ? '' : sessionStorage.getItem('tstop');
      this.searchParams.obs_id = sessionStorage.getItem('obs_id')===null ? '' : sessionStorage.getItem('obs_id');
      this.searchParams.isarchived = sessionStorage.getItem('isarchived')==='true' ? true : false;
      this.searchParams.operation = sessionStorage.getItem('operation')===null ? 1 : parseInt(sessionStorage.getItem('operation'));
      this.searchParams.proposal = sessionStorage.getItem('proposal')===null ? '' : sessionStorage.getItem('proposal');

      this.currentPage = sessionStorage.getItem('currentPage')===null ? 1 : parseInt(sessionStorage.getItem('currentPage'));
      this.pageSize = sessionStorage.getItem('pageSize')===null ? 10 : parseInt(sessionStorage.getItem('pageSize'));
    },
    handleBulkDownload(data){
      if(this.multipleSelection){
        this.multipleSelection.forEach(row =>{
          if(!row.isDownload){
            this.$refs.multipleTable.toggleRowSelection(row,false);
          }
        })
      }
      if(this.multipleSelection.length===0){
        alert('请选择数据!(Please select the data to download !)')
        return;
      }
      let urls = [];
      
      this.multipleSelection.forEach((dataitem)=>{
        let childurl = dataitem.selectedLevels.filter((item) => {
          return item.isShow && item.value;
        }).map((itemLevel) => {
          if(dataitem.isAuthed === 'ok' && !(data.type === 'bulkwget')) {
            return window.location.protocol+'//'+window.location.host+'/iapi/usrdownload/'+itemLevel.level+'/'+dataitem.auth_code;
          } else if(!(dataitem.isAuthed === 'ok') && !(data.type === 'bulkwget')) {
            if (!this.userInfo) {
              return window.location.protocol+'//'+window.location.host+'/iapi/downloadopen/'+itemLevel.level+'/'+dataitem.auth_code;
            }
            return window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/'+itemLevel.level+'/'+dataitem.auth_code;
          }else if(dataitem.isAuthed === 'ok' && data.type === 'bulkwget'){
            return ' wget -c -t 0 -O '+itemLevel.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/usrdownload/'+itemLevel.level+'/'+dataitem.auth_code;
          }else if(!(dataitem.isAuthed === 'ok') && data.type === 'bulkwget'){
            if (!this.userInfo) {
              return ' wget -c -t 0 -O '+itemLevel.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/downloadopen/'+itemLevel.level+'/'+dataitem.auth_code;
            }
            return ' wget -c -t 0 -O '+itemLevel.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/'+itemLevel.level+'/'+dataitem.auth_code;
          }
          // if(dataitem.isAuthed === 'ok') {
          //   return window.location.protocol+'//'+window.location.host+'/iapi/usrdownload/'+itemLevel.level+'/'+dataitem.auth_code;
          // } else {
          //   return window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/'+itemLevel.level+'/'+dataitem.auth_code;
          // }
        });
        urls = urls.concat(childurl);

      });
      if(urls.length<1){
        alert('请选择要下载的数据产品级别!(Please select the data product level to download !)');
        return;
      }
      if (data.type === 'bulkdown') {
        urls.forEach((item) => {
          // console.log('下载地址',item);
          // window.open(item);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = item; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
        });
      }
      if (data.type === 'bulkcopy') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'bulkwget') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
        // this.copyTextDialogData = urls.map((item) => {
        //   return 'wget ' + item;
        // }).join('\r\n');
        // this.copyTextDialogVisible = true;
      }
    },
    handleSelectionChange(val){
      this.list.forEach(item=>{
        const ids=val.map(citem=>{
          return citem.id
        })
        if(!ids.includes(item.id)){
          item.selectedLevels.forEach(selectitem=>{
            if(selectitem.value){
              selectitem.value=false;
            }
          })
        }
      })
      // console.log('val',val);
      this.multipleSelection = val;
    },
    toggleSelection(scope, i){
      const row = scope.row;
      const index = scope.$index;
      row.selectedLevels[i].value = !row.selectedLevels[i].value;
      let res = row.selectedLevels.some((levelItem) => {
        return levelItem.value;
      });
      this.$refs.multipleTable.toggleRowSelection(row, res);
      this.$set(this.list, index, row);
    },
    tabSelection(level) {
      let flag;
      if (level === '1L') {
        flag = this.level1L;
      } else if (level === '15L') {
        flag = this.level15L;
      } else if(level === '2L'){
        flag = this.level2L;
      }

      this.list.forEach((item, index) => {
        item.selectedLevels.forEach((levelItem, i) => {
          if (levelItem.level === level &&  levelItem.isShow && item.isDownload) {
            item.selectedLevels[i].value = !flag;
            this.$set(this.list, index, item);
          }
        });
        let res = item.selectedLevels.some((levelItem) => {
          return levelItem.value;
        });
        this.$refs.multipleTable.toggleRowSelection(item, res);
      });
    },
    batchapply(){
      if(this.multipleSelection){
        this.multipleSelection.forEach(row =>{
          if(!row.isApply){
            this.$refs.multipleTable.toggleRowSelection(row,false);
          }
        })
      }
      if(this.multipleSelection.length===0){
        alert('请选择可申请数据!(Please select applicable data!)')
        return;
      }else if(this.multipleSelection.length<2){
        alert('请选择多条可申请数据，单条数据请直接点击申请按钮!(Please select more than one application data. For single data, please click the application button directly!)')
        return;
      }
      // console.log('选中数据',this.multipleSelection);
      if(this.userInfo){
        // console.log("登录用户姓名",this.userInfo.truename);
        this.logincurrentDataIdbulk = this.multipleSelection;
        this.LoginApplyIsVisiblebulk = true;
      }   
    },
    UpPackagedown(obs_id){
      this.$router.push(`/DataUpPackageDown/`+obs_id);
    },
    Ownerauth(data){
      const params = {
        data:data,
        usr:this.userInfo,
      }
      axios.post('/iapi/OwnerAuth',params).then((res) => {
        if (res.data.errcode === 0) {
          this.getData();
        }else{
          this.$message.error('Owner用户链接生成报错！');
        }
      });
    },
    
  },
};
</script>

<style lang="scss" scoped>
.search-proposal {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.el-form-item {
    margin-bottom: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 22px;
  padding-bottom: 2px;
}
.selected-levels {
  display: inline-flex;
  border: 1px solid #0058a3;
  margin-top: 10px;
  margin-right: 6px;
  .level-item {
    padding: 3px 6px;
    color: #0058a3;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    border-right: 1px solid #0058a3;
  }
  .level-item:last-child{
    border-right: none;
  }
  .level-item-active {
    color: #fff;
    background: #0058a3;
    border-color: #fff;
  }
}
.upk-levels {
  display: inline-flex;
  border: 1px solid #0058a3;
  margin-top: 0px;
  margin-right: 6px;
  .upklevel-item {
    padding: 2px 6px;
    color: #0058a3;
    font-size: 8px;
    line-height: 1;
    cursor: pointer;
    border-right: 1px solid #0058a3;
  }
}
.el-divider {
    display: block;
    height: 1px;
    width: 100%;
    margin: 1px 0;
}
</style>
